"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_provider_1 = require("../config-provider");
var LocaleReceiver_1 = tslib_1.__importDefault(require("../locale-provider/LocaleReceiver"));
var empty_1 = tslib_1.__importDefault(require("./empty"));
var simple_1 = tslib_1.__importDefault(require("./simple"));
var defaultEmptyImg = React.createElement(empty_1.default, null);
var simpleEmptyImg = React.createElement(simple_1.default, null);
var Empty = function (_a) {
    var className = _a.className, customizePrefixCls = _a.prefixCls, _b = _a.image, image = _b === void 0 ? defaultEmptyImg : _b, description = _a.description, children = _a.children, imageStyle = _a.imageStyle, restProps = tslib_1.__rest(_a, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);
    var _c = React.useContext(config_provider_1.ConfigContext), getPrefixCls = _c.getPrefixCls, direction = _c.direction;
    return (React.createElement(React.Fragment, null,
        React.createElement(LocaleReceiver_1.default, { componentName: "Empty" }, function (locale) {
            var _a;
            var prefixCls = getPrefixCls('empty', customizePrefixCls);
            var des = typeof description !== 'undefined' ? description : locale.description;
            var alt = typeof des === 'string' ? des : 'empty';
            var imageNode = null;
            if (typeof image === 'string') {
                imageNode = React.createElement("img", { alt: alt, src: image });
            }
            else {
                imageNode = image;
            }
            return (React.createElement("div", tslib_1.__assign({ className: (0, classnames_1.default)(prefixCls, (_a = {},
                    _a["".concat(prefixCls, "-normal")] = image === simpleEmptyImg,
                    _a["".concat(prefixCls, "-rtl")] = direction === 'rtl',
                    _a), className) }, restProps),
                React.createElement("div", { className: "".concat(prefixCls, "-image"), style: imageStyle }, imageNode),
                des && React.createElement("div", { className: "".concat(prefixCls, "-description") }, des),
                children && React.createElement("div", { className: "".concat(prefixCls, "-footer") }, children)));
        })));
};
Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
exports.default = Empty;
//# sourceMappingURL=index.js.map